export default __webpack_public_path__ + "static/media/china.83eeddf0.png";